import { ImportFileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ImportFile')
export class ImportFileNodeSchemaProvider extends SchemaProvider<ImportFileWorkflowNode> {}
